import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/697512271beda800144fd2bf/pink_diamond_corporate/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/697512271beda800144fd2bf/pink_diamond_corporate/src/app/solutions/components/SolutionsInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/697512271beda800144fd2bf/pink_diamond_corporate/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/697512271beda800144fd2bf/pink_diamond_corporate/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/697512271beda800144fd2bf/pink_diamond_corporate/src/components/ui/AppImage.tsx");
